import { Controller } from "@hotwired/stimulus"

// After a Lexxy upload completes, watches for the attachment figure to appear in the
// editor DOM. If the browser cannot render the image (e.g. HEIC/HEIF), the onerror
// handler swaps the src to the app's thumbnail endpoint, which gracefully falls back
// to serving the raw file rather than showing a broken image.
export default class extends Controller {
  connect() {
    this.element.addEventListener("lexxy:upload-end", this.#onUploadEnd)
  }

  disconnect() {
    this.element.removeEventListener("lexxy:upload-end", this.#onUploadEnd)
  }

  #onUploadEnd = ({ detail: { error } }) => {
    if (error) return

    const observer = new MutationObserver((mutations) => {
      for (const { addedNodes } of mutations) {
        for (const node of addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue

          const img = node.tagName === "IMG" ? node : node.querySelector("img")
          if (!img) continue

          const signedId = this.#signedIdFrom(img.src)
          if (!signedId) continue

          const thumbnailSrc = `/thumbnail?signed_id=${signedId}&w=1024&h=768`

          img.addEventListener("error", () => { img.src = thumbnailSrc }, { once: true })

          // Handle the case where the browser already attempted and failed before
          // the listener was attached (naturalWidth === 0 on a completed load means failure)
          if (img.complete && img.naturalWidth === 0) img.src = thumbnailSrc

          observer.disconnect()
          return
        }
      }
    })

    observer.observe(this.element, { childList: true, subtree: true })
    setTimeout(() => observer.disconnect(), 10_000)
  }

  #signedIdFrom(url) {
    const match = url.match(/\/rails\/active_storage\/blobs\/redirect\/([^/?]+)/)
    return match?.[1] ?? null
  }
}
